import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { maxBy, minBy } from 'lodash'
import { Viewer } from '@teqplay/viewer'

// Components (relative)
import BollardAxis from '../../terminalPlanner/bollardAxis/BollardAxis'
// CSS (relative)
import './TerminalPreview.scss'
import { QUAY_ROLES } from '../../../js/constants'

class TerminalPreview extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      height: 0
    }
    this._resizeRaf = null
  }

  static propTypes = {
    config: PropTypes.object.isRequired
  }

  componentWillUnmount() {
    if (this._resizeRaf) {
      cancelAnimationFrame(this._resizeRaf)
      this._resizeRaf = null
    }
  }

  render() {
    const startTime = new Date()
    const endTime = new Date()

    const quaysToRender = this.props.config.quays.filter(
      quay => typeof quay.minBollard === 'number' && quay.maxBollard && quay.role === QUAY_ROLES.normal
    )

    if (!quaysToRender || !quaysToRender.length) {
      return null
    }

    const startBollard = minBy(quaysToRender, quay => quay.minBollard).minBollard
    const endBollard = maxBy(quaysToRender, quay => quay.maxBollard).maxBollard

    return (
      <Viewer
        xMargin={20}
        width={this.state.width}
        height={this.state.height}
        onResize={this.handleResize}
        yType={'Date'}
        xType={'Number'}
        yStart={startTime}
        yEnd={endTime}
        xStart={startBollard}
        xEnd={endBollard}
      >
        {({ measureRef, xUnitToScreen }) => (
          <div className="terminal-preview-contents">
            <div className="terminal-preview-panel" ref={measureRef}>
              <BollardAxis bollardToScreen={xUnitToScreen} config={this.props.config} showExternal={false} />
            </div>
          </div>
        )}
      </Viewer>
    )
  }

  handleResize = dimensions => {
    // Schedule state updates outside the ResizeObserver delivery to avoid feedback loops
    if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf)
    this._resizeRaf = requestAnimationFrame(() => {
      this.setState(prev => {
        if (prev.width === dimensions.width && prev.height === dimensions.height) {
          return null
        }
        return {
          width: dimensions.width,
          height: dimensions.height
        }
      })
    })
  }
}

export default TerminalPreview
